import { TUNING as T } from './tuning';

/**
 * The suit's numbers that permanent upgrades change (GDD: Upgrades). The simulations take these
 * instead of reading the tuning directly, so a run plays with whatever the lab has built.
 */
export interface SuitStats {
  readonly armorMax: number;
  readonly starlightMax: number;
  /** Starlight the jetpack burns per tick. */
  readonly jetDrainPerTick: number;
  /** Starlight regained per tick standing on the ground. */
  readonly regenPerTickGrounded: number;
  /** The highest radiation tier the suit stands safely (GDD: Radiation). */
  readonly shielding: number;
  /** Weapon mods the suit can hold at once. */
  readonly modSlots: number;
}

/** The suit with no upgrades. */
export const BASE_SUIT: SuitStats = {
  armorMax: T.armorMax,
  starlightMax: T.starlightMax,
  jetDrainPerTick: T.jetDrainPerTick,
  regenPerTickGrounded: T.regenPerTickGrounded,
  shielding: 0,
  modSlots: 0,
};
